import React, { ReactNode } from "react";

export const Container = ({
    children,
    mode = "image-bottom",
    xlMode = "image-right",
    backdrop,
    className,
}: {
    children: [ReactNode, ReactNode];
    mode?: "image-bottom" | "image-top";
    xlMode?: "image-left" | "image-right";
    backdrop?: ReactNode;
    className?: string;
}) => {
    return (
        <div
            className={`
                grid grid-cols-1 gap-12 lg:gap-28 items-center relative ${className}
                ${
                    xlMode === "image-left"
                        ? "lg:grid-cols-[calc(100%-500px-112px)_500px]"
                        : "lg:grid-cols-[500px_1fr]"
                }
            `}
        >
            {backdrop}
            <div
                className={`
                        relative flex flex-col
                        ${mode === "image-top" ? "order-1" : "order-2"}
                        ${
                            xlMode === "image-left"
                                ? "lg:order-1 items-end"
                                : "lg:order-2 items-start"
                        }
                    `}
            >
                {children[1]}
            </div>
            <div
                className={`
                        relative 
                        ${mode === "image-top" ? "order-2" : "order-1"}
                        ${xlMode === "image-left" ? "lg:order-2" : "lg:order-1"}
                    `}
            >
                {children[0]}
            </div>
        </div>
    );
};
